import React, { useState, useRef, useEffect } from 'react';
import Layout from 'Layout'
import './styles.scss'
import { DatePicker } from 'antd';
import dayjs from 'dayjs'
import { mixGetV1, mixPostV1, mixPutV1 } from 'services/mixin';
import { toast } from "react-toastify";
import IdentityVerification from './IndentifyVerification';
import { useTranslation } from 'react-i18next';

const Dashboard: React.FC = () => {
  const [isModalShown, setModalShown] = useState(false);
  const [isShowFormEdit, setShowFormEdit] = useState(false);
  const [username, setUsername] = useState<string>('')
  const [emailUser, setEmailUser] = useState<string>('')
  const [getBirth, setGetBirth] = useState<string>('')
  const [firstName, setFirstName] = useState<string>('')
  const [lastName, setLastName] = useState<string>('')
  const [phone, setPhone] = useState<string>('')
  const [country, setCountry] = useState<string>('')
  const [gender, setGender] = useState<number | null>()
  const [city, setCity] = useState<string>('')
  const [address, setAddress] = useState<string>('')
  const [postalCode, setpostalCode] = useState<string>('')
  const [idUser, setIduser] = useState<number | null>(null)
  const [countryNotice, setCountryNotice] = useState<boolean>(false)
  const [cityNotice, setCityNotice] = useState<boolean>(false)
  const [addressNotice, setAddressNotice] = useState<boolean>(false)
  const [birthdayNotice, setBirthdayNotice] = useState<boolean>(false)
  const [postalNotice, setPostalNotice] = useState<boolean>(false)
  const [avatarLetter, setAvatarLetter] = useState<string>('')
  const [avatarFile, setAvatarFile] = useState<File | null>(null)
  const [getName, setGetName] = useState<string>('')

  useEffect(() => {
    const userData = localStorage.getItem('user');

    if (userData) {
      const user = JSON.parse(userData)

      const lang = localStorage.getItem('i18nextLng')

      if (lang === 'en') setGetName(`${user.first_name} ${user.last_name}`)
      if (lang === 'vi') setGetName(`${user.last_name} ${user.first_name}`)
    }

  }, [])

  const { t } = useTranslation();

  const handleShowFormEdit = () => {
    setShowFormEdit(!isShowFormEdit);
  };
  const handleShowModal = () => {
    setModalShown(!isModalShown);
  };

  const fileInputRef = useRef<HTMLInputElement>(null);
  const [avatarPreview, setAvatarPreview] = useState(JSON.parse(localStorage.getItem('user') || '{}').avatar_url);
  const [dragOver, setDragOver] = useState(false);

  useEffect(() => {
    const getUser = localStorage.getItem('user')
    if (getUser) {
      try {
        const user = JSON.parse(getUser)
        const getUsername = `${user.first_name} ${user.last_name}`
        const getAvatar = user.last_name?.slice(0, 1)
        setAvatarLetter(getAvatar)
        if (getUsername === 'null null') {
          setUsername('Unknown')
        } else {
          setUsername(getUsername)
        }
        setEmailUser(user.email)
      } catch (error) {
        console.error('Lỗi parse JSON:', error)
      }
    }
  }, [])

  const handleClickDropzone = () => {
    fileInputRef.current?.click();
  };

  const fileToBase64 = (file: File): Promise<string> => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = (error) => reject(error);
    });
  };


  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      setAvatarFile(file);
      const previewURL = URL.createObjectURL(file);
      setAvatarPreview(previewURL);
    }
  };

  const handleDrop = (e: React.DragEvent<HTMLFormElement>) => {
    e.preventDefault();
    setDragOver(false);

    const file = e.dataTransfer.files?.[0];
    if (file) {
      setAvatarFile(file);
      const previewURL = URL.createObjectURL(file);
      setAvatarPreview(previewURL);
    }
  };

  const handleDragOver = (e: React.DragEvent<HTMLFormElement>) => {
    e.preventDefault();
    setDragOver(true);
  };

  const handleDragLeave = () => {
    setDragOver(false);
  };

  useEffect(() => {
    const userData = localStorage.getItem('user');

    if (userData) {
      const user = JSON.parse(userData);

      setAvatarPreview(user.avatar_url)
    }
  }, [])

  const handleUpload = async (file: File) => {
    try {
      const previewURL = URL.createObjectURL(file);
      setAvatarPreview(previewURL);
      setShowFormEdit(false);
      const userData = localStorage.getItem('user');

      if (userData) {
        const user = JSON.parse(userData);
        const base64String = await fileToBase64(file);

        const res = await mixPutV1(`/api/v1/be/user/${user.id}`, {
          avatar: base64String
        })

        if (res.status) {
          const res2 = await mixGetV1(`/api/v1/be/user/${user.id}`)

          if (res2.status) {
            localStorage.setItem('user', JSON.stringify(res2.data))
            window.location.reload()
          }
        }
      }

    } catch (err) {
      console.error("Error converting file:", err);
    }
  };

  function formatDate(input: string): string {
    const date = new Date(input);

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
  }

  const editFuncs = async () => {
    function convertDate(input: string): string {
      const [day, month, year] = input.split("/");
      return `${year}-${month}-${day}`;
    }

    const dateHandle = getBirth ? convertDate(getBirth) : ''

    function removeEmpty(obj: any) {
      return Object.fromEntries(
        Object.entries(obj).filter(([_, v]) => v !== undefined && v !== null && v !== "")
      );
    }

    const payload = removeEmpty({
      avatar: avatarFile ? await fileToBase64(avatarFile) : undefined,
      first_name: firstName,
      last_name: lastName,
      phone,
      country,
      city,
      address,
      postal_code: postalCode,
      birthday: dateHandle ? String(dateHandle) : undefined, // ép sang string nếu có
      is_active: true, // nếu luôn cần thì để nguyên
      gender,
    })

    const res = await mixPutV1(`/api/v1/be/user/${idUser}`, payload)

    if (res.status) {
      const res2 = await mixGetV1(`/api/v1/be/user/${idUser}`)

      toast.success('Updated account information successfully', {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });

      if (res2.status) {
        localStorage.setItem('user', JSON.stringify(res.data))

        const getUser = localStorage.getItem('user')

        if (getUser) {
          try {
            const user = JSON.parse(getUser)
            const getUsername = `${user.first_name} ${user.last_name}`
            setUsername(getUsername)
            setEmailUser(user.email)
            const handleBirthday = user.birthday ? formatDate(user.birthday) : ''
            setGetBirth(handleBirthday)
            setFirstName(user.first_name)
            setLastName(user.last_name)
            setPhone(user.phone)
            setCountry(user.country ? user.country : '')
            setGender(user.gender ? user.gender : 1)
            setCity(user.city ? user.city : '')
            setAddress(user.address ? user.address : '')
            setIduser(user.id)
          } catch (error) {
            console.error('Lỗi parse JSON:', error)
          }
        }
      }

      window.location.reload();
    } else {
      toast.error('Updated account information failed', {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  }

  useEffect(() => {
    if (country !== '') setCountryNotice(false)
    if (city !== '') setCityNotice(false)
    if (address !== '') setAddressNotice(false)
    if (postalCode !== '') setPostalNotice(false)
    if (getBirth !== '') setBirthdayNotice(false)
  }, [country, city, address, postalCode, getBirth])

  useEffect(() => {
    const getUser = localStorage.getItem('user')

    if (getUser) {
      try {
        const user = JSON.parse(getUser)
        const getUsername = `${user.first_name} ${user.last_name}`
        setUsername(getUsername)
        setEmailUser(user.email)
        const handleBirthday = user.birthday ? formatDate(user.birthday) : ''
        setGetBirth(handleBirthday)
        setFirstName(user.first_name)
        setLastName(user.last_name)
        setPhone(user.phone)
        setCountry(user.country ? user.country : '')
        setGender(user.gender ? user.gender : 1)
        setCity(user.city ? user.city : '')
        setAddress(user.address ? user.address : '')
        setIduser(user.id)
      } catch (error) {
        console.error('Lỗi parse JSON:', error)
      }
    }
  }, [])

  return (
    <Layout>
      <>
        <nav className="breadcrumb__container mb-3">
          <div className="breadcrumb__gradient breadcrumb__gradient--left" data-gradient="left" style={{ display: 'none' }}></div>
          <ul className="breadcrumb" data-breadcrumb-scroll-container="">
            <li className="breadcrumb-item"><a href="/accounts-overview">{t("Trader")}</a></li>
            <li className="breadcrumb-item ">
              <a href="/profile">
                {t("Profile")}
              </a>
            </li>
            <li className="breadcrumb-item active">{t('PersonalInformation')}</li>
          </ul>
          <div className="breadcrumb__gradient breadcrumb__gradient--right" data-gradient="right" style={{ display: 'none' }}></div>
        </nav>

        <div className="section-header mb-4">
          <div className="section-title">
            <div className="section-title__title-wrap">
              <div className="section-title__icon">
                <i className="fi fi--user fi--themed"></i>
              </div>
              <div className="section-title--main">{t("Profile")}</div>
            </div>
          </div>
          <div className="section-header__tabs">
            <ul className="nav nav-tabs">
              <li className="nav-item">
                <a href="/profile" className="nav-link active">
                  <span className="nav-link__label">{t('PersonalInformation')}</span>
                </a>
              </li>
              <li className="nav-item">
                <a href="/profile/account" className="nav-link">
                  <span className="nav-link__label">{t('AccountInformation')}</span>
                </a>
              </li>
              <li className="nav-item">
                <a href="/profile/security" className="nav-link ">
                  <span className="nav-link__label">{t('Security')}</span>
                </a>
              </li>
              {/* <li className="nav-item">
                <a href="/profile/teams" className="nav-link ">
                  <span className="nav-link__label">{t("Teams")}</span>
                </a>
              </li> */}
              <li className="nav-item">
                <a href="/profile/affiliate" className="nav-link ">
                  <span className="nav-link__label">{t('Affiliates')}</span>
                </a>
              </li>
              <li className="nav-item">
                <a href="/profile/inventory" className="nav-link ">
                  <span className="nav-link__label">{t('Inventory')}</span>
                </a>
              </li>
              <li className="nav-item" style={{ pointerEvents: 'none', cursor: 'default', color: 'gray', opacity: '0.6' }}>
                <a href="#" data-notification-target="nav-profile-identity" className="nav-link disabled" tabIndex={-1} aria-disabled="true">
                  <span className="nav-link__label">{t('LUMIRIdentity')}</span>
                </a>
              </li>
              <li className="nav-item" style={{ pointerEvents: 'none', cursor: 'default', color: 'gray', opacity: '0.6' }}>
                <a href="#" className="nav-link disabled" tabIndex={-1} aria-disabled="true">
                  <span className="nav-link__label">{t('EmailNewsletters')}</span>
                </a>
              </li>
              <li className="nav-item" style={{ pointerEvents: 'none', cursor: 'default', color: 'gray', opacity: '0.6' }}>
                <a href="#" className="nav-link disabled" tabIndex={-1} aria-disabled="true">
                  <span className="nav-link__label">{t('LUMIRPoints')}</span>
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="portlet mb-4">
          <div className="profile-bio__container">
            <div className="profile-bio__picture-wrap" data-avatar-with-picture="false">
              <div className="d-block text-decoration-none text-center">
                <div className="avatar avatar--2xl profile-bio__picture"
                  onClick={handleShowFormEdit}
                  style={{ width: '80px', height: '80px' }}>
                  <img src={avatarPreview} alt="" className="avatar__img"
                    ref={(img: HTMLImageElement | null) => {
                      if (!img) return;
                      if (!img.dataset.cacheBusted) {
                        const separator = avatarPreview && avatarPreview.includes('?') ? '&' : '?';
                        img.src = `${avatarPreview}${separator}cb=${Date.now()}`;
                        img.dataset.cacheBusted = '1';
                      }
                    }}
                    onError={(e) => {
                      const img = e.currentTarget as HTMLImageElement;
                      //const color = '#' + Math.floor(Math.random() * 16777215).toString(16).padStart(6, '0');

                      const fallback = document.createElement('div');
                      fallback.className = 'avatar__img avatar__fallback';
                      fallback.style.display = 'flex';
                      fallback.style.alignItems = 'center';
                      fallback.style.justifyContent = 'center';
                      fallback.style.background = '#e9b460';
                      fallback.style.color = '#fff';
                      fallback.style.fontWeight = '700';
                      fallback.style.fontSize = '32px';
                      fallback.style.width = '100%';
                      fallback.style.height = '100%';
                      fallback.style.borderRadius = getComputedStyle(img).borderRadius || '50%';
                      const svgns = "http://www.w3.org/2000/svg";
                      const svg = document.createElementNS(svgns, "svg");
                      svg.setAttribute("viewBox", "0 0 256 256");
                      svg.setAttribute("xmlns", svgns);
                      svg.setAttribute("width", "48");
                      svg.setAttribute("height", "48");
                      svg.style.maxWidth = "100%";
                      svg.style.height = "auto";

                      const rect = document.createElementNS(svgns, "rect");
                      rect.setAttribute("width", "256");
                      rect.setAttribute("height", "256");
                      rect.setAttribute("fill", "none");

                      const circle = document.createElementNS(svgns, "circle");
                      circle.setAttribute("cx", "128");
                      circle.setAttribute("cy", "96");
                      circle.setAttribute("r", "64");
                      circle.setAttribute("fill", "none");
                      circle.setAttribute("stroke", "currentColor");
                      circle.setAttribute("stroke-linecap", "round");
                      circle.setAttribute("stroke-linejoin", "round");
                      circle.setAttribute("stroke-width", "16");

                      const path = document.createElementNS(svgns, "path");
                      path.setAttribute("d", "M32,216c19.37-33.47,54.55-56,96-56s76.63,22.53,96,56");
                      path.setAttribute("fill", "none");
                      path.setAttribute("stroke", "currentColor");
                      path.setAttribute("stroke-linecap", "round");
                      path.setAttribute("stroke-linejoin", "round");
                      path.setAttribute("stroke-width", "16");

                      svg.appendChild(rect);
                      svg.appendChild(circle);
                      svg.appendChild(path);

                      fallback.appendChild(svg);

                      img.replaceWith(fallback);
                    }}
                    onLoad={(e) => {
                      const img = e.currentTarget as HTMLImageElement;
                      img.style.display = 'block';
                    }}
                  />
                  {/* <img src='/images/avatar.jpg' alt="" className="avatar__img" /> */}
                  {/* <div className="avatar__badge">{avatarLetter}</div> */}
                </div>
              </div>
            </div>
            <div className="profile-bio__info-wrap">
              <div className="profile-bio__info-name profile-bio__row mb-2">
                <span className="profile-bio__row-label">{getName == 'null null' ? 'Unknown' : getName}</span>
                <i
                  className="fi fi--edit profile-bio__row-icon--md"
                  onClick={handleShowFormEdit}
                ></i>
              </div>
              <div className="profile-bio__info-nickname-div d-none profile-bio__row mb-2">
                <span className="profile-bio__info-nickname profile-bio__row-label">
                </span>
              </div>
              <div className="profile-bio__info-email profile-bio__row mb-2 text-break">
                <i className="fi fi--user fi--primary profile-bio__row-icon"></i>
                <span className="profile-bio__row-label">{emailUser}</span>
              </div>
              <div className="profile-bio__row">
                <i className="fi fi--coin-stack fi--primary profile-bio__row-icon"></i>
                <div is="ftmo-points" data-testid="points" className="profile-bio__row-label">0</div>
                <span className="profile-bio__points-label">{t('LUMIRPoints')}</span>
              </div>
            </div>
            <button
              type="button"
              id="editNicknameBtn"
              className="btn btn-secondary profile-bio__edit-info-btn"
              onClick={handleShowModal}
            >{t('EditNickname')}</button>
          </div>
        </div>

        {isShowFormEdit && (
          <div className="portlet mb-4">
            <div id="avatar-settings">
              <div className="h6">
                {t('Profilepicturesettings')}
              </div>
              <div className="upload_wrapper profile-picture-settings">
                <div className="row">
                  <div className="col-12 text-center">
                    <div id="close_img_wrapper">
                      <div className="profile-bio__picture flex justify-center items-center" >
                        <img src={avatarPreview} alt="" className="avatar__img avatar-preview-image"
                          style={{
                            width: '120px',
                            height: '120px',
                            borderRadius: '9999px',
                          }}
                          ref={(img: HTMLImageElement | null) => {
                            if (!img) return;
                            if (!img.dataset.cacheBusted) {
                              const separator = avatarPreview && avatarPreview.includes('?') ? '&' : '?';
                              img.src = `${avatarPreview}${separator}cb=${Date.now()}`;
                              img.dataset.cacheBusted = '1';
                            }
                          }}
                          onError={(e) => {
                            const img = e.currentTarget as HTMLImageElement;
                            const color = '#' + Math.floor(Math.random() * 16777215).toString(16).padStart(6, '0');

                            const fallback = document.createElement('div');
                            fallback.className = 'avatar__img avatar__fallback';
                            fallback.style.display = 'flex';
                            fallback.style.alignItems = 'center';
                            fallback.style.justifyContent = 'center';
                            fallback.style.background = '#e9b460';
                            fallback.style.color = '#fff';
                            fallback.style.fontWeight = '700';
                            fallback.style.fontSize = '32px';
                            fallback.style.width = '100%';
                            fallback.style.height = '100%';
                            fallback.style.borderRadius = getComputedStyle(img).borderRadius || '50%';
                            const svgns = "http://www.w3.org/2000/svg";
                            const svg = document.createElementNS(svgns, "svg");
                            svg.setAttribute("viewBox", "0 0 256 256");
                            svg.setAttribute("xmlns", svgns);
                            svg.setAttribute("width", "48");
                            svg.setAttribute("height", "48");
                            svg.style.maxWidth = "100%";
                            svg.style.height = "auto";

                            const rect = document.createElementNS(svgns, "rect");
                            rect.setAttribute("width", "256");
                            rect.setAttribute("height", "256");
                            rect.setAttribute("fill", "none");

                            const circle = document.createElementNS(svgns, "circle");
                            circle.setAttribute("cx", "128");
                            circle.setAttribute("cy", "96");
                            circle.setAttribute("r", "64");
                            circle.setAttribute("fill", "none");
                            circle.setAttribute("stroke", "currentColor");
                            circle.setAttribute("stroke-linecap", "round");
                            circle.setAttribute("stroke-linejoin", "round");
                            circle.setAttribute("stroke-width", "16");

                            const path = document.createElementNS(svgns, "path");
                            path.setAttribute("d", "M32,216c19.37-33.47,54.55-56,96-56s76.63,22.53,96,56");
                            path.setAttribute("fill", "none");
                            path.setAttribute("stroke", "currentColor");
                            path.setAttribute("stroke-linecap", "round");
                            path.setAttribute("stroke-linejoin", "round");
                            path.setAttribute("stroke-width", "16");

                            svg.appendChild(rect);
                            svg.appendChild(circle);
                            svg.appendChild(path);

                            fallback.appendChild(svg);

                            img.replaceWith(fallback);
                          }}
                          onLoad={(e) => {
                            const img = e.currentTarget as HTMLImageElement;
                            img.style.display = 'block';
                          }}
                        />
                      </div>
                    </div>
                    <div id="avatar-delete-image" className="btn btn-sm link link-danger disabled mt-2 avatar-dropzone__delete delete-image">
                      {t('Delete')}
                    </div>
                    <div className="alert alert--primary mb-3">
                      <div className="alert__content">
                        <div className="alert__content-header">
                          <div className="alert__icon">
                            <i className="fi fi--challenge-exclamation"></i>
                          </div>
                        </div>
                        <div className="alert__content-body">
                          <div>{t('avatarNote')}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="avatar-dropzone">
                      <form
                        id="dropzone"
                        className="avatar-dropzone__form dz-clickable"
                        onClick={handleClickDropzone}
                        onDrop={handleDrop}
                        onDragOver={handleDragOver}
                        onDragLeave={handleDragLeave}
                        encType="multipart/form-data"
                      >
                        <div className={`dz-message avatar-dropzone__area ${dragOver ? 'is-dragover' : ''}`} data-dz-message="">
                          <i className="fi fi--plus-in-circle fi--themed me-2"></i>
                          <span className="">
                            {t('danddorclicktoselect')}
                          </span>
                        </div>
                        <input
                          type="file"
                          name="avatar"
                          accept="image/*"
                          style={{ display: 'none' }}
                          ref={fileInputRef}
                          onChange={handleFileChange}
                        />
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        <div className={`modal fade profile-bio__modal ${isModalShown ? 'show' : ''}`} id="modalEditProfileInfo" aria-hidden={!isModalShown} role="dialog">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">{t('EditMyProfile')}</h5>
                <button onClick={handleShowModal} type="button" className="btn-close" data-bs-dismiss="modal"></button>
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="col-12">
                    <div className="alert alert--warning mb-3">
                      <div className="alert__content">
                        <div className="alert__content-header">
                          <div className="alert__icon">
                            <i className="fi fi--challenge-exclamation"></i>
                          </div>
                        </div>
                        <div className="alert__content-body">
                          <div>{t('nicknameNote')}</div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-12">
                    <label htmlFor="nickname" className="form-label">{t("Nickname")}</label>
                    <input type="text" id="nickname" name="nickname" className="form-control" pattern="^[a-zA-Z0-9_\-\.]{5,20}$" title="Nickname must be in range 5-20 characters. Only alphanumeric and _ - . characters." />
                    <div id="nickname-response" className="profile-bio__feedback-message"></div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal" onClick={handleShowModal}>
                  {t('Close')}
                </button>
                <input type="hidden" name="csrf-token" />
                <button type="button" id="save-social" className="btn btn-primary" onClick={handleShowModal}>
                  {t("Save")}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className={`modal-backdrop fade ${isModalShown ? 'show' : ''}`} onClick={handleShowModal}></div>
        <div className="portlet mb-4 " id="error_avatar_message_port">
          <div id="avatar-error-container">
            <span id="avatar-error-msg" className="text-danger d-none">Failed to load avatar image.</span>
            <img
              src={avatarPreview}
              alt=""
              style={{ display: 'none' }}
              onError={() => {
                const msg = document.getElementById('avatar-error-msg');
                if (msg) msg.classList.remove('d-none');
              }}
              onLoad={() => {
                const msg = document.getElementById('error_avatar_message_port');
                if (msg) msg.classList.add('d-none');
              }}
            />
          </div>
        </div>
        {/* action="/profile/change_personal_info" method="post" */}

        <div className="needs-validation mt-4" id="form_profile" data-submit-prevent-message="Biểu mẫu có chứa dữ liệu không được phép gửi đi.">
          <h6>Client</h6>
          <div className="portlet mt-3 mb-4 pt-0">
            <div className="portlet__body">
              <div className="row">
                <div className="col-12 col-md-6 mb-4">
                  <label htmlFor="last_name" className="form-label">{t('LastName')}</label>
                  <input type="text" id="last_name" name="last_name" className="form-control " required={true} pattern="^[^&lt;&gt;±!@£$%^&amp;_+§¡€#¢§¶•ªº«\/\\&lt;&gt;?:;\|=.,]{1,50}$" value={lastName} onChange={(e) => setLastName(e.target.value)} />
                  <div className="invalid-feedback">{t('LastNameRequired')}</div>
                </div>
                <div className="col-12 col-md-6 mb-4">
                  <label htmlFor="first_name" className="form-label">{t('FirstName')}</label>
                  <input type="text" id="first_name" name="first_name" className="form-control " required={true} pattern="^[^&lt;&gt;±!@£$%^&amp;_+§¡€#¢§¶•ªº«\/\\&lt;&gt;?:;\|=.,]{1,50}$" value={firstName} onChange={(e) => setFirstName(e.target.value)} />
                  <div className="invalid-feedback">{t('FirstNameRequired')}</div>
                </div>
              </div>
              <div className="row">
                <div className="col-12 col-md-6">
                  <label htmlFor="title" className="form-label">{t('Gender')}</label>
                  {/* <select id="title" name="title" className="form-select " required value={gender ?? ""} onChange={(e) => setGender(Number(e.target.value))}>
                    <option value="Mr" selected={true}> Mr </option>
                    <option value="Mrs"> Mrs </option>
                    <option value="Ms"> Ms </option>
                    <option value="Mx"> Mx </option>
                  </select> */}
                  <select
                    id="title"
                    name="title"
                    className="form-select"
                    required
                    value={gender !== null ? gender : ""}
                    onChange={(e) =>
                      setGender(Number(e.target.value))
                    }
                  >
                    <option value="">{t('SelectGender')}</option>
                    <option value={2}>{t('female')}</option>
                    <option value={1}>{t('male')}</option>
                  </select>
                </div>
                <div className="col-12 col-md-6 cts-input-birthday">
                  <label htmlFor="" className='form-label'>{t("Birthday")}</label>
                  <DatePicker
                    style={{ width: '100%' }}
                    format="DD/MM/YYYY"
                    value={getBirth ? dayjs(getBirth, "DD/MM/YYYY") : null}
                    onChange={(_, dateString) => {
                      setGetBirth(dateString as string);
                    }}
                    className='form-select'
                  />
                  <div className={birthdayNotice ? 'valid-feedback' : 'invalid-feedback'}>{t('BirthdayNote')}.</div>
                </div>
              </div>
            </div>
          </div>

          {/* <IdentityVerification
            userId={idUser !== null ? idUser : undefined}
          /> */}

          <h6>{t('ContactInformation')}</h6>
          <div className="portlet mt-3 mb-5 pt-0">
            <div className="portlet__body">
              <div className="row">
                <div className="col-12 col-md-6 mb-4">
                  <label htmlFor="phone" className="form-label">{t('PhoneNumber')}</label>
                  <input type="tel" id="phone" name="phone" pattern="^(?=.*\d)[ 0-9\+\-\(\)]{5,20}$" className="form-control " required={true} value={phone} onChange={(e) => setPhone(e.target.value)} />
                  <div className="invalid-feedback">{t('PhoneNumberNote')}</div>
                </div>
                <div className="col-12 col-md-6 mb-4">
                  <label htmlFor="email" className="form-label">{t('EmailAddress')}</label>
                  <input type="email" id="email" name="email" className="form-control form-control--disabled" disabled={true} readOnly={true} value={emailUser} />
                  <div className="invalid-feedback">{t('EmailAddressNote')}</div>
                </div>
              </div>
              <div className="row">
                <div className="col-12 col-md-6 mb-4">
                  <label htmlFor="country" className="form-label">{t('CountryofResidence')}</label>
                  <select id="country" name="country" className="form-select " required={true} value={country} onChange={(e) => setCountry(e.target.value)}>
                    <option value="" disabled>
                      -- {t('Selectcountry')} --
                    </option>
                    <option value="AX" data-country-id="9"> Åland Islands </option>
                    <option value="AL" data-country-id="10"> Albania </option>
                    <option value="DZ" data-country-id="11"> Algeria </option>
                    <option value="AD" data-country-id="13"> Andorra </option>
                    <option value="AO" data-country-id="14"> Angola </option>
                    <option value="AR" data-country-id="18"> Argentina </option>
                    <option value="AM" data-country-id="19"> Armenia </option>
                    <option value="AW" data-country-id="20"> Aruba </option>
                    <option value="AU" data-country-id="251"> Australia </option>
                    <option value="AT" data-country-id="2"> Austria </option>
                    <option value="AZ" data-country-id="21"> Azerbaijan </option>
                    <option value="BS" data-country-id="22"> Bahamas </option>
                    <option value="BH" data-country-id="23"> Bahrain </option>
                    <option value="BD" data-country-id="24"> Bangladesh </option>
                    <option value="BB" data-country-id="25"> Barbados </option>
                    <option value="BE" data-country-id="27"> Belgium </option>
                    <option value="BJ" data-country-id="29"> Benin </option>
                    <option value="BM" data-country-id="30"> Bermuda </option>
                    <option value="BO" data-country-id="32"> Bolivia, Plurinational State of </option>
                    <option value="BQ" data-country-id="33"> Bonaire, Sint Eustatius and Saba </option>
                    <option value="BA" data-country-id="34"> Bosnia and Herzegovina </option>
                    <option value="BW" data-country-id="35"> Botswana </option>
                    <option value="BR" data-country-id="37"> Brazil </option>
                    <option value="IO" data-country-id="38"> British Indian Ocean Territory </option>
                    <option value="BN" data-country-id="39"> Brunei Darussalam </option>
                    <option value="BG" data-country-id="40"> Bulgaria </option>
                    <option value="BF" data-country-id="41"> Burkina Faso </option>
                    <option value="KH" data-country-id="43"> Cambodia </option>
                    <option value="CM" data-country-id="44"> Cameroon </option>
                    <option value="CA" data-country-id="45"> Canada </option>
                    <option value="KY" data-country-id="47"> Cayman Islands </option>
                    <option value="CL" data-country-id="50"> Chile </option>
                    <option value="CN" data-country-id="51"> China </option>
                    <option value="CX" data-country-id="52"> Christmas Island </option>
                    <option value="CC" data-country-id="53"> Cocos (Keeling) Islands </option>
                    <option value="CO" data-country-id="54"> Colombia </option>
                    <option value="CD" data-country-id="57"> Congo, the Democratic Republic of the </option>
                    <option value="CR" data-country-id="59"> Costa Rica </option>
                    <option value="CI" data-country-id="60"> Côte d'Ivoire </option>
                    <option value="HR" data-country-id="61"> Croatia </option>
                    <option value="CW" data-country-id="63"> Curaçao </option>
                    <option value="CY" data-country-id="64"> Cyprus </option>
                    <option value="CZ" data-country-id="3"> Czech Republic </option>
                    <option value="DK" data-country-id="65"> Denmark </option>
                    <option value="DO" data-country-id="68"> Dominican Republic </option>
                    <option value="EC" data-country-id="69"> Ecuador </option>
                    <option value="EG" data-country-id="70"> Egypt </option>
                    <option value="SV" data-country-id="71"> El Salvador </option>
                    <option value="EE" data-country-id="74"> Estonia </option>
                    <option value="ET" data-country-id="75"> Ethiopia </option>
                    <option value="FK" data-country-id="76"> Falkland Islands (Malvinas) </option>
                    <option value="FO" data-country-id="77"> Faroe Islands </option>
                    <option value="FI" data-country-id="79"> Finland </option>
                    <option value="FR" data-country-id="80"> France </option>
                    <option value="GF" data-country-id="81"> French Guiana </option>
                    <option value="PF" data-country-id="82"> French Polynesia </option>
                    <option value="TF" data-country-id="83"> French Southern Territories </option>
                    <option value="GE" data-country-id="86"> Georgia </option>
                    <option value="DE" data-country-id="4"> Germany </option>
                    <option value="GH" data-country-id="87"> Ghana </option>
                    <option value="GI" data-country-id="88"> Gibraltar </option>
                    <option value="GR" data-country-id="89"> Greece </option>
                    <option value="GL" data-country-id="90"> Greenland </option>
                    <option value="GP" data-country-id="92"> Guadeloupe </option>
                    <option value="GT" data-country-id="94"> Guatemala </option>
                    <option value="GG" data-country-id="95"> Guernsey </option>
                    <option value="GY" data-country-id="98"> Guyana </option>
                    <option value="HT" data-country-id="99"> Haiti </option>
                    <option value="HM" data-country-id="100"> Heard Island and McDonald Islands </option>
                    <option value="HN" data-country-id="102"> Honduras </option>
                    <option value="HK" data-country-id="103"> Hong Kong </option>
                    <option value="HU" data-country-id="104"> Hungary </option>
                    <option value="IS" data-country-id="105"> Iceland </option>
                    <option value="IE" data-country-id="110"> Ireland </option>
                    <option value="IM" data-country-id="111"> Isle of Man </option>
                    <option value="IL" data-country-id="112"> Israel </option>
                    <option value="IT" data-country-id="113"> Italy </option>
                    <option value="JM" data-country-id="114"> Jamaica </option>
                    <option value="JP" data-country-id="115"> Japan </option>
                    <option value="JE" data-country-id="116"> Jersey </option>
                    <option value="JO" data-country-id="117"> Jordan </option>
                    <option value="KE" data-country-id="119"> Kenya </option>
                    <option value="KR" data-country-id="122"> Korea, Republic of </option>
                    <option value="KW" data-country-id="123"> Kuwait </option>
                    <option value="LA" data-country-id="126"> Lao People's Democratic Republic </option>
                    <option value="LV" data-country-id="127"> Latvia </option>
                    <option value="LB" data-country-id="128"> Lebanon </option>
                    <option value="LY" data-country-id="131"> Libya </option>
                    <option value="LI" data-country-id="132"> Liechtenstein </option>
                    <option value="LT" data-country-id="133"> Lithuania </option>
                    <option value="LU" data-country-id="134"> Luxembourg </option>
                    <option value="MO" data-country-id="135"> Macao </option>
                    <option value="MK" data-country-id="136"> Macedonia, the former Yugoslav Republic of </option>
                    <option value="MG" data-country-id="137"> Madagascar </option>
                    <option value="MY" data-country-id="139"> Malaysia </option>
                    <option value="MV" data-country-id="140"> Maldives </option>
                    <option value="MT" data-country-id="142"> Malta </option>
                    <option value="MQ" data-country-id="144"> Martinique </option>
                    <option value="MU" data-country-id="146"> Mauritius </option>
                    <option value="YT" data-country-id="147"> Mayotte </option>
                    <option value="MX" data-country-id="148"> Mexico </option>
                    <option value="MD" data-country-id="150"> Moldova, Republic of </option>
                    <option value="MC" data-country-id="151"> Monaco </option>
                    <option value="MN" data-country-id="152"> Mongolia </option>
                    <option value="ME" data-country-id="153"> Montenegro </option>
                    <option value="MS" data-country-id="154"> Montserrat </option>
                    <option value="MA" data-country-id="155"> Morocco </option>
                    <option value="MZ" data-country-id="156"> Mozambique </option>
                    <option value="NA" data-country-id="158"> Namibia </option>
                    <option value="NP" data-country-id="160"> Nepal </option>
                    <option value="NL" data-country-id="161"> Netherlands </option>
                    <option value="NC" data-country-id="162"> New Caledonia </option>
                    <option value="NZ" data-country-id="163"> New Zealand </option>
                    <option value="NI" data-country-id="164"> Nicaragua </option>
                    <option value="NG" data-country-id="166"> Nigeria </option>
                    <option value="NF" data-country-id="168"> Norfolk Island </option>
                    <option value="NO" data-country-id="170"> Norway </option>
                    <option value="OM" data-country-id="171"> Oman </option>
                    <option value="PK" data-country-id="172"> Pakistan </option>
                    <option value="PW" data-country-id="173"> Palau </option>
                    <option value="PS" data-country-id="174"> Palestinian Territory, Occupied </option>
                    <option value="PA" data-country-id="175"> Panama </option>
                    <option value="PY" data-country-id="177"> Paraguay </option>
                    <option value="PE" data-country-id="178"> Peru </option>
                    <option value="PH" data-country-id="179"> Philippines </option>
                    <option value="PN" data-country-id="180"> Pitcairn </option>
                    <option value="PL" data-country-id="5"> Poland </option>
                    <option value="PT" data-country-id="181"> Portugal </option>
                    <option value="QA" data-country-id="183"> Qatar </option>
                    <option value="RE" data-country-id="184"> Réunion </option>
                    <option value="RO" data-country-id="185"> Romania </option>
                    <option value="RW" data-country-id="187"> Rwanda </option>
                    <option value="SH" data-country-id="189"> Saint Helena, Ascension and Tristan da Cunha </option>
                    <option value="MF" data-country-id="192"> Saint Martin (French part) </option>
                    <option value="PM" data-country-id="193"> Saint Pierre and Miquelon </option>
                    <option value="SA" data-country-id="198"> Saudi Arabia </option>
                    <option value="SN" data-country-id="199"> Senegal </option>
                    <option value="RS" data-country-id="200"> Serbia </option>
                    <option value="SG" data-country-id="203"> Singapore </option>
                    <option value="SX" data-country-id="204"> Sint Maarten (Dutch part) </option>
                    <option value="SK" data-country-id="6"> Slovakia </option>
                    <option value="SI" data-country-id="205"> Slovenia </option>
                    <option value="ZA" data-country-id="208"> South Africa </option>
                    <option value="GS" data-country-id="209"> South Georgia and the South Sandwich Islands </option>
                    <option value="ES" data-country-id="211"> Spain </option>
                    <option value="LK" data-country-id="212"> Sri Lanka </option>
                    <option value="SJ" data-country-id="215"> Svalbard and Jan Mayen </option>
                    <option value="SE" data-country-id="217"> Sweden </option>
                    <option value="CH" data-country-id="218"> Switzerland </option>
                    <option value="TW" data-country-id="220"> Taiwan </option>
                    <option value="TZ" data-country-id="222"> Tanzania, United Republic of </option>
                    <option value="TH" data-country-id="223"> Thailand </option>
                    <option value="TG" data-country-id="225"> Togo </option>
                    <option value="TT" data-country-id="228"> Trinidad and Tobago </option>
                    <option value="TN" data-country-id="229"> Tunisia </option>
                    <option value="TR" data-country-id="230"> Turkey </option>
                    <option value="TC" data-country-id="232"> Turks and Caicos Islands </option>
                    <option value="UG" data-country-id="234"> Uganda </option>
                    <option value="UA" data-country-id="235"> Ukraine </option>
                    <option value="AE" data-country-id="236"> United Arab Emirates </option>
                    <option value="GB" data-country-id="7"> United Kingdom </option>
                    <option value="UY" data-country-id="239"> Uruguay </option>
                    <option value="VN" data-country-id="243"> Viet Nam </option>
                    <option value="VG" data-country-id="244"> Virgin Islands, British </option>
                    <option value="WF" data-country-id="246"> Wallis and Futuna </option>
                    <option value="YE" data-country-id="248"> Yemen </option>
                    <option value="ZM" data-country-id="249"> Zambia </option>
                    <option value="ZW" data-country-id="250"> Zimbabwe </option>
                  </select>
                  <div className={countryNotice ? 'valid-feedback' : 'invalid-feedback'}>{t('CountryNote')}.</div>
                </div>
                {/* <div id="states" className="form-group col-12 col-md-6 mb-4 d-none">
                  <label htmlFor="state" className="form-label">Bang</label>
                  <select id="state" name="state" autoComplete="off" className="form-select  ">
                    <option disabled value="" id="state-placeholder" selected={true}> Vui lòng chọn tiểu bang </option>
                    <option className="d-none disabled" value="AZ" data-country-id="236"> Abu Dhabi </option>
                    <option className="d-none disabled" value="AJ" data-country-id="236"> Ajman </option>
                    <option className="d-none disabled" value="AL" data-country-id="237"> Alabama </option>
                    <option className="d-none disabled" value="AK" data-country-id="237"> Alaska </option>
                    <option className="d-none disabled" value="AB" data-country-id="45"> Alberta </option>
                    <option className="d-none disabled" value="AZ" data-country-id="237"> Arizona </option>
                    <option className="d-none disabled no-service-state" value="AR" data-country-id="237"> Arkansas </option>
                    <option className="d-none disabled" value="ACT" data-country-id="251"> Australian Capital Territory </option>
                    <option className="d-none disabled" value="BC" data-country-id="45"> British Columbia </option>
                    <option className="d-none disabled" value="CA" data-country-id="237"> California </option>
                    <option className="d-none disabled" value="CO" data-country-id="237"> Colorado </option>
                    <option className="d-none disabled" value="CT" data-country-id="237"> Connecticut </option>
                    <option className="d-none disabled no-service-state" value="DE" data-country-id="237"> Delaware </option>
                    <option className="d-none disabled" value="DC" data-country-id="237"> District of Columbia </option>
                    <option className="d-none disabled" value="DU" data-country-id="236"> Dubai </option>
                    <option className="d-none disabled" value="FL" data-country-id="237"> Florida </option>
                    <option className="d-none disabled" value="FU" data-country-id="236"> Fujairah </option>
                    <option className="d-none disabled" value="GA" data-country-id="237"> Georgia </option>
                    <option className="d-none disabled" value="HI" data-country-id="237"> Hawaii </option>
                    <option className="d-none disabled" value="ID" data-country-id="237"> Idaho </option>
                    <option className="d-none disabled" value="IL" data-country-id="237"> Illinois </option>
                    <option className="d-none disabled" value="IN" data-country-id="237"> Indiana </option>
                    <option className="d-none disabled" value="IA" data-country-id="237"> Iowa </option>
                    <option className="d-none disabled" value="KS" data-country-id="237"> Kansas </option>
                    <option className="d-none disabled" value="KY" data-country-id="237"> Kentucky </option>
                    <option className="d-none disabled no-service-state" value="LA" data-country-id="237"> Louisiana </option>
                    <option className="d-none disabled" value="ME" data-country-id="237"> Maine </option>
                    <option className="d-none disabled" value="MB" data-country-id="45"> Manitoba </option>
                    <option className="d-none disabled" value="MD" data-country-id="237"> Maryland </option>
                    <option className="d-none disabled" value="MA" data-country-id="237"> Massachusetts </option>
                    <option className="d-none disabled" value="MI" data-country-id="237"> Michigan </option>
                    <option className="d-none disabled" value="MN" data-country-id="237"> Minnesota </option>
                    <option className="d-none disabled" value="MS" data-country-id="237"> Mississippi </option>
                    <option className="d-none disabled" value="MO" data-country-id="237"> Missouri </option>
                    <option className="d-none disabled no-service-state" value="MT" data-country-id="237"> Montana </option>
                    <option className="d-none disabled" value="NE" data-country-id="237"> Nebraska </option>
                    <option className="d-none disabled" value="NV" data-country-id="237"> Nevada </option>
                    <option className="d-none disabled" value="NB" data-country-id="45"> New Brunswick </option>
                    <option className="d-none disabled" value="NH" data-country-id="237"> New Hampshire </option>
                    <option className="d-none disabled" value="NJ" data-country-id="237"> New Jersey </option>
                    <option className="d-none disabled" value="NM" data-country-id="237"> New Mexico </option>
                    <option className="d-none disabled" value="NSW" data-country-id="251"> New South Wales </option>
                    <option className="d-none disabled" value="NY" data-country-id="237"> New York </option>
                    <option className="d-none disabled" value="NL" data-country-id="45"> Newfoundland and Labrador </option>
                    <option className="d-none disabled" value="NC" data-country-id="237"> North Carolina </option>
                    <option className="d-none disabled" value="ND" data-country-id="237"> North Dakota </option>
                    <option className="d-none disabled" value="NT" data-country-id="251"> Northern Territory </option>
                    <option className="d-none disabled" value="NT" data-country-id="45"> Northwest Territories </option>
                    <option className="d-none disabled" value="NS" data-country-id="45"> Nova Scotia </option>
                    <option className="d-none disabled" value="NU" data-country-id="45"> Nunavut </option>
                    <option className="d-none disabled" value="OH" data-country-id="237"> Ohio </option>
                    <option className="d-none disabled" value="OK" data-country-id="237"> Oklahoma </option>
                    <option className="d-none disabled" value="ON" data-country-id="45"> Ontario </option>
                    <option className="d-none disabled" value="OR" data-country-id="237"> Oregon </option>
                    <option className="d-none disabled" value="PA" data-country-id="237"> Pennsylvania </option>
                    <option className="d-none disabled" value="PE" data-country-id="45"> Prince Edward Island </option>
                    <option className="d-none disabled" value="QC" data-country-id="45"> Quebec </option>
                    <option className="d-none disabled" value="QLD" data-country-id="251"> Queensland </option>
                    <option className="d-none disabled" value="RK" data-country-id="236"> Ras Al Khaimah </option>
                    <option className="d-none disabled" value="RI" data-country-id="237"> Rhode Island </option>
                    <option className="d-none disabled" value="SK" data-country-id="45"> Saskatchewan </option>
                    <option className="d-none disabled" value="SH" data-country-id="236"> Sharjah </option>
                    <option className="d-none disabled" value="SA" data-country-id="251"> South Australia </option>
                    <option className="d-none disabled no-service-state" value="SC" data-country-id="237"> South Carolina </option>
                    <option className="d-none disabled" value="SD" data-country-id="237"> South Dakota </option>
                    <option className="d-none disabled" value="TAS" data-country-id="251"> Tasmania </option>
                    <option className="d-none disabled" value="TN" data-country-id="237"> Tennessee </option>
                    <option className="d-none disabled" value="TX" data-country-id="237"> Texas </option>
                    <option className="d-none disabled" value="UQ" data-country-id="236"> Umm Al Quwain </option>
                    <option className="d-none disabled" value="UT" data-country-id="237"> Utah </option>
                    <option className="d-none disabled" value="VT" data-country-id="237"> Vermont </option>
                    <option className="d-none disabled" value="VIC" data-country-id="251"> Victoria </option>
                    <option className="d-none disabled" value="VA" data-country-id="237"> Virginia </option>
                    <option className="d-none disabled" value="WA" data-country-id="237"> Washington </option>
                    <option className="d-none disabled" value="WV" data-country-id="237"> West Virginia </option>
                    <option className="d-none disabled" value="WA" data-country-id="251"> Western Australia </option>
                    <option className="d-none disabled" value="WI" data-country-id="237"> Wisconsin </option>
                    <option className="d-none disabled" value="WY" data-country-id="237"> Wyoming </option>
                    <option className="d-none disabled" value="YT" data-country-id="45"> Yukon </option>
                  </select>
                  <div className="invalid-feedback">Invalid state code for the given country.</div>
                </div> */}
                <div className="col-12 col-md-6">
                  <label htmlFor="zip_code" className="form-label">{t('PostalCode')}</label>
                  <input type="text" id="zip_code" name="zip_code" pattern="^(?!\s)[ a-zA-Z0-9\-\._\/]{3,10}(?&lt;!\s)$" className="form-control placeholder:!text-[#7d7d7f]" required={true} value={postalCode} onChange={(e) => setpostalCode(e.target.value)} placeholder='Please fill your postal code' />
                  <div className={postalNotice ? 'valid-feedback' : 'invalid-feedback'}>{t('PostalCodeNote')}</div>
                </div>
              </div>


              <div className="mb-3 alert alert--danger alert-au-order d-none">
                <div className="alert__content">
                  <div className="alert__content-header">
                    <div className="alert__icon">
                      <i className="fi fi--triangle-exclamation"></i>
                    </div>
                  </div>
                  <div className="alert__content-body">
                    <div>{t('updateAustralia')}
                      <a href="/customer-support" target="_blank" className="text--danger"> {t('Contactusnow')} </a>
                    </div>
                  </div>
                </div>
              </div>

              {/* <div className="row">
                <div className="col-12 col-md-6 mb-4">
                  <label htmlFor="city" className="form-label">City</label>
                  <input type="text" id="city" name="city" pattern="^[^&lt;&gt;]{1,50}$" className="form-control " required={true} value={city} onChange={(e) => setCity(e.target.value)} placeholder='Please fill your city' />
                  <div className={cityNotice ? 'valid-feedback' : 'invalid-feedback'}>City must be between 1 and 50 characters.</div>
                </div>
                <div className="col-12 col-md-6 mb-4">
                  <label htmlFor="street" className="form-label">Address</label>
                  <input type="text" id="street" name="street" pattern="^[^&lt;&gt;]{1,100}$" className="form-control " required={true} value={address} onChange={(e) => setAddress(e.target.value)} placeholder='Please fill your address' />
                  <div className={addressNotice ? 'valid-feedback' : 'invalid-feedback'}>Address must be between 1 and 100 characters.</div>
                </div>
              </div> */}
              {/* <div className="row">
                <div className="col-12 col-md-6">
                  <label htmlFor="zip_code" className="form-label">Postal Code</label>
                  <input type="text" id="zip_code" name="zip_code" pattern="^(?!\s)[ a-zA-Z0-9\-\._\/]{3,10}(?&lt;!\s)$" className="form-control " required={true} value={postalCode} onChange={(e) => setpostalCode(e.target.value)} placeholder='Please fill your postal code' />
                  <div className={postalNotice ? 'valid-feedback' : 'invalid-feedback'}>Postal code must contain only letters (uppercase and lowercase), numbers, '-', '.', '_', '/' and must be between 3 and 10 characters long.</div>
                </div>
              </div> */}
            </div>
          </div>

          <div className="alert alert--warning my-5">
            <div className="alert__content">
              <div className="alert__content-header">
                <div className="alert__icon">
                  <i className="fi fi--challenge-exclamation"></i>
                </div>
              </div>
              <div className="alert__content-body">
                <div>
                  {t('registrationWarning')}
                </div>
              </div>
            </div>
          </div>
          <div className="text-center mb-5">
            <input type="hidden" name="csrf-token" value="e390c6c53614f7733371ba7fb6be2374" />
            <button id="submit-personal-information" type="submit" className="btn-primary btn col-8 mb-3 col-md-4 mx-md-3 my-md-0" onClick={editFuncs}>
              Save
            </button>
          </div>
        </div>

        <div className="footer mb-5 mb-md-auto">
          <div className="row my-4 small">
            <div className="col-12 small text-center text-md-end mb-md-1 mb-2 fw-bold">
              <a href="#" id="ftmo-cookie-settings" className=""> {t('CookieSettings')} </a>
              &nbsp;
              <a href="#" data-bs-toggle="modal" data-bs-target="#modal_privacy_policy"> {t('PrivacyPolicy')} </a>
              &nbsp;
              <a href="#" id="footer__link-terms-conditions"> {t('TermsConditions')} </a>
            </div>

            <div className="col-12 small">
              <div className="col-12 small">
                <p className="text-justify">
                  {t('disclaimerFull')}
                </p>
              </div>
            </div>
            {/* <div className="col-12 small text-left">2025 © Copyright - LUMIR.com Made with <span className="text-danger">❤</span> for trading.</div>
            <div className="col-12">
              <small>Version: 2566ae6f </small>
            </div> */}
          </div>
        </div>
      </>
    </Layout>
  )
}
export default Dashboard